import { TextPairing } from '@components/TextPairing/TextPairing';
import { themeMediaQuery, themeVariant } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    font-weight: 700;
    ${themeVariant('featureCopy17')};
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      ${themeVariant('dek20')};
    }
  }
`;
